import React from 'react';
import { motion } from 'framer-motion';
import { CodeIcon, CheckCircleIcon } from 'lucide-react';
import { SlideLayout, itemVariants } from '../ui/SlideLayout';
export function IntegrationSlide() {
  return <SlideLayout data-id="element-251" data-mp="pp1uj8ve6fay">
      <motion.div variants={itemVariants} className="mb-12 text-center" data-id="element-252" data-mp="pqmnwv5yzs78">
        <h2 className="text-4xl md:text-5xl font-bold text-brand-text mb-4" data-id="element-253" data-mp="krjg52ylv7vk">
          Drop-In Replacement.{' '}
          <span className="text-brand-teal" data-id="element-254" data-mp="1hfzk442gpjs7">One API Key Swap.</span>
        </h2>
        <p className="text-xl text-brand-text-dim" data-id="element-255" data-mp="1dew6lo7vzzu5">
          The simplicity of the code IS the message.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto mb-12" data-id="element-256" data-mp="18ermzpbomozp">
        {/* Before Code */}
        <motion.div variants={itemVariants} className="rounded-xl overflow-hidden border border-brand-border shadow-2xl" data-id="element-257" data-mp="13jc9wzli0x4c">
          <div className="bg-[#161b22] px-4 py-2 border-b border-brand-border flex items-center gap-2" data-id="element-258" data-mp="3o77cemozxz4k">
            <div className="flex gap-1.5" data-id="element-259" data-mp="1mltaxh9xllja">
              <div className="w-3 h-3 rounded-full bg-red-500/20 border border-red-500/50" data-id="element-260" data-mp="1mjyqe42knvfq" />
              <div className="w-3 h-3 rounded-full bg-yellow-500/20 border border-yellow-500/50" data-id="element-261" data-mp="1qmvcw5v8gboy" />
              <div className="w-3 h-3 rounded-full bg-green-500/20 border border-green-500/50" data-id="element-262" data-mp="1cnnal43rwngj" />
            </div>
            <span className="text-xs text-brand-text-muted ml-2 font-mono" data-id="element-263" data-mp="1hot7le4guwvv">
              Before (OpenAI)
            </span>
          </div>
          <div className="bg-[#0d1117] p-6 text-sm font-mono overflow-x-auto" data-id="element-264" data-mp="17p2ar5sfo5sm">
            <pre className="text-brand-text-dim" data-id="element-265" data-mp="txnu35m00goq">
              <code data-id="element-266" data-mp="tyyxh4bj7mfb">
                <span className="text-pink-400" data-id="element-267" data-mp="tvksrpfeb14p">import</span> openai{'\n\n'}
                client <span className="text-pink-400" data-id="element-268" data-mp="ywqlhn922oe8">=</span> openai.OpenAI(
                {'\n'}
                {'  '}api_key<span className="text-pink-400" data-id="element-269" data-mp="k1b006mjk0tg">=</span>
                <span className="text-green-400" data-id="element-270" data-mp="oykptndueeht">"sk-proj-..."</span>,{'\n'})
                {'\n\n'}
                response <span className="text-pink-400" data-id="element-271" data-mp="5uhhixpm31x3">=</span>{' '}
                client.chat.completions.create({'\n'}
                {'  '}model<span className="text-pink-400" data-id="element-272" data-mp="11o99zuxpbg9">=</span>
                <span className="text-green-400" data-id="element-273" data-mp="3s8hdzdoxrspj">"gpt-4"</span>,{'\n'}
                {'  '}messages<span className="text-pink-400" data-id="element-274" data-mp="3naplahggw2ka">=</span>[{'\n'}
                {'    '}
                {'{'} <span className="text-green-400" data-id="element-275" data-mp="osa76yb85fcj">"role"</span>:{' '}
                <span className="text-green-400" data-id="element-276" data-mp="oqhaobubsbi9">"user"</span>,{' '}
                <span className="text-green-400" data-id="element-277" data-mp="jus9k42nqmju">"content"</span>:{' '}
                <span className="text-green-400" data-id="element-278" data-mp="etuqlp9tpoha">"Hello"</span> {'}'}
                {'\n'}
                {'  '}]{'\n'})
              </code>
            </pre>
          </div>
        </motion.div>

        {/* After Code */}
        <motion.div variants={itemVariants} className="rounded-xl overflow-hidden border border-brand-teal shadow-[0_0_30px_rgba(0,212,170,0.15)] relative" data-id="element-279" data-mp="2zloaink5wfbu">
          <div className="bg-[#161b22] px-4 py-2 border-b border-brand-border flex items-center gap-2" data-id="element-280" data-mp="1a496v86al54i">
            <div className="flex gap-1.5" data-id="element-281" data-mp="1f3m3gkmytqka">
              <div className="w-3 h-3 rounded-full bg-red-500/20 border border-red-500/50" data-id="element-282" data-mp="1f0hnyr41v8eb" />
              <div className="w-3 h-3 rounded-full bg-yellow-500/20 border border-yellow-500/50" data-id="element-283" data-mp="1jzkkfn5ys6ao" />
              <div className="w-3 h-3 rounded-full bg-green-500/20 border border-green-500/50" data-id="element-284" data-mp="1ougpbnwauo57" />
            </div>
            <span className="text-xs text-brand-teal ml-2 font-mono" data-id="element-285" data-mp="1ttt91zrvjf3k">
              After (Isochron)
            </span>
          </div>
          <div className="bg-[#0d1117] p-6 text-sm font-mono overflow-x-auto relative" data-id="element-286" data-mp="22rvin3pobg2g">
            <pre className="text-brand-text-dim" data-id="element-287" data-mp="27rroz9lufjl6">
              <code data-id="element-288" data-mp="27qgk16gnw5sh">
                <span className="text-pink-400" data-id="element-289" data-mp="27ovn5a6vkarg">import</span> openai{'\n\n'}
                client <span className="text-pink-400" data-id="element-290" data-mp="8g8g0v0jibbi">=</span> openai.OpenAI(
                {'\n'}
                <div className="bg-brand-teal/20 -mx-6 px-6 py-0.5 border-l-2 border-brand-teal" data-id="element-291" data-mp="ddgyyxtiijdt">
                  {'  '}base_url<span className="text-pink-400" data-id="element-292" data-mp="23w5fmnrz1otd">=</span>
                  <span className="text-green-400" data-id="element-293" data-mp="1yug1v0dd6x1l">
                    "https://api.isochron.cloud/v1"
                  </span>
                  ,
                </div>
                <div className="bg-brand-teal/20 -mx-6 px-6 py-0.5 border-l-2 border-brand-teal" data-id="element-294" data-mp="28svuj7s1ied7">
                  {'  '}api_key<span className="text-pink-400" data-id="element-295" data-mp="1l31k0wv711w4">=</span>
                  <span className="text-green-400" data-id="element-296" data-mp="1l1gn50lep6v3">"iso_sk_live_..."</span>,
                </div>
                ){'\n\n'}
                response <span className="text-pink-400" data-id="element-297" data-mp="1twodggbxht25">=</span>{' '}
                client.chat.completions.create({'\n'}
                <div className="bg-brand-teal/20 -mx-6 px-6 py-0.5 border-l-2 border-brand-teal" data-id="element-298" data-mp="1p4dat5pszt5w">
                  {'  '}model<span className="text-pink-400" data-id="element-299" data-mp="11eizisl4ucnr">=</span>
                  <span className="text-green-400" data-id="element-300" data-mp="xei9eaoo8d0v">"llama-3.1-8b-fpga"</span>,
                </div>
                {'  '}messages<span className="text-pink-400" data-id="element-301" data-mp="n9s35sm8imqu">=</span>[{'\n'}
                {'    '}
                {'{'} <span className="text-green-400" data-id="element-302" data-mp="s1jwgawrz6ko">"role"</span>:{' '}
                <span className="text-green-400" data-id="element-303" data-mp="s2v08aq80ebs">"user"</span>,{' '}
                <span className="text-green-400" data-id="element-304" data-mp="ddgsf72am4yi">"content"</span>:{' '}
                <span className="text-green-400" data-id="element-305" data-mp="iafineiu5rrf">"Hello"</span> {'}'}
                {'\n'}
                {'  '}]{'\n'})
              </code>
            </pre>
          </div>
        </motion.div>
      </div>

      <motion.div variants={itemVariants} className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto" data-id="element-306" data-mp="1b05vzlcn8pmh">
        <div className="flex items-start gap-3" data-id="element-307" data-mp="w2dlx8pv8tfo">
          <CheckCircleIcon className="w-5 h-5 text-brand-teal flex-shrink-0 mt-0.5" data-id="element-308" data-mp="1116xgvllead7" />
          <p className="text-sm text-brand-text-dim" data-id="element-309" data-mp="3gt4anmvumvoi">
            Standard REST API. Works with any HTTP client. Python & TS SDKs
            available.
          </p>
        </div>
        <div className="flex items-start gap-3" data-id="element-310" data-mp="3lpkz6i6ync24">
          <CheckCircleIcon className="w-5 h-5 text-brand-teal flex-shrink-0 mt-0.5" data-id="element-311" data-mp="1s86wjkidz4le" />
          <p className="text-sm text-brand-text-dim" data-id="element-312" data-mp="1n9vkr48j6k0j">
            Zero FPGA expertise needed. No hardware provisioning or firmware
            updates.
          </p>
        </div>
        <div className="flex items-start gap-3" data-id="element-313" data-mp="1dklsnodot1cf">
          <CheckCircleIcon className="w-5 h-5 text-brand-teal flex-shrink-0 mt-0.5" data-id="element-314" data-mp="1djsuvcwphm6f" />
          <p className="text-sm text-brand-text-dim" data-id="element-315" data-mp="18m0s1nuiwfng">
            Sign up → receive API key → start sending requests immediately.
          </p>
        </div>
      </motion.div>
    </SlideLayout>;
}